export default __webpack_public_path__ + "static/media/logo2.aeb6067e.png";